export default function getCategoryRelatedLinks(state) {
  const links = state.category.relatedCategories || [];

  return links;
}
